import React from 'react';
import './styles.scss';
import ReallyNiceImage from 'assets/about-us/Really Nice.svg';
import ReallyCleanImage from 'assets/about-us/Really Clean.svg';
import ReallyRealImage from 'assets/about-us/Really Real.svg';

const AboutUsUbainDifferenceSection = () => {
  return (
    <div className="__AboutUsUbainDifferenceSection text-center font_lato __my-container">
      <h4 className="font_montserrat font-weight-mediam-bold __primary-text-color __title">The Urbain Difference</h4>
      <div className="__wrapper d-lg-flex">
        <div className="__dummy d-none d-lg-block">
          <img src={ReallyNiceImage} alt="" className="invisible __blog-image" />
          <h5 className="font-weight-mediam-bold font_montserrat __heading">u</h5>
        </div>
        <div>
          <img src={ReallyNiceImage} alt="" className="__blog-image" />
          <h5 className="font-weight-mediam-bold font_montserrat __heading">Really. Nice.</h5>
          <p className="__blog-section">Thoughtfully curated experiences in the best homes, not just a place to sleep.</p>
        </div>
        <div className="py-3 py-lg-0">
          <img src={ReallyCleanImage} alt="" className="__blog-image" />
          <h5 className="font-weight-mediam-bold font_montserrat __heading">Really. Clean.</h5>
          <p className="__blog-section">Cleaned and sanitized by highly trained professionals using up-to-date techniques and protocols.</p>
        </div>
        <div>
          <img src={ReallyRealImage} alt="" className="__blog-image" />
          <h5 className="font-weight-mediam-bold font_montserrat __heading">Really. Real.</h5>
          <p className="__blog-section">We've verified each home to ensure that what you see is what you'll get.</p>
        </div>
        <div className="__dummy d-none d-lg-block">
          <img src={ReallyRealImage} alt="" className="__blog-image invisible" />
          <h5 className="font-weight-mediam-bold font_montserrat __heading">u</h5>
        </div>
      </div>
    </div>
  );
};

export default AboutUsUbainDifferenceSection;
